export enum HOME_TRACKING_EVENTS {
  TDAE_INTEREST_HOMEPAGE = 'TDAE_INTEREST_HOMEPAGE',
}
